import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import solutions from "../assets/figma/solutions.svg";
import wealth from "../assets/figma/wealth.svg";
import advisory from "../assets/figma/advisory.svg";
import "../css/Home.css";

function Home() {
  const { t } = useTranslation();
  return (
    <main id="home">
      <section className="home-hero">
        <div className="home-claim"><h1>{t("main.home.claim")}</h1></div>
      </section>
      <section className="home-intro"><p>{t("main.home.introText")}</p></section>
      <section className="home-expertise" aria-labelledby="expertise-heading">
        <h2 id="expertise-heading">{t("main.home.expertiseTitle")}</h2>
        <p className="expertise-intro">{t("main.home.expertiseIntro")}</p>
        <div className="expertise-grid">
          {[["solutions", solutions], ["wealth", wealth], ["advisory", advisory]].map(([key, icon]) => (
            <article className="expertise-item" key={key}>
              <div className="expertise-icon"><img src={icon} alt="" /></div>
              <div><h3>{t(`main.home.expertise.${key}.title`)}</h3>
              <p>{t(`main.home.expertise.${key}.text`)}</p></div>
            </article>
          ))}
        </div>
        <Link to="/services" className="expertise-button">{t("main.home.expertiseButton")}</Link>
      </section>
      <section className="home-goals">
        <h2>{t("main.home.goalsTitle")}</h2><p>{t("main.home.goalsText")}</p>
      </section>
    </main>
  );
}
export default Home;
